import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

export interface EntityAttribute {
  fCustomDataEntity: string;
  fCustomDataAttributeName: string;
  fCustomDataAttributeLabel: string;
  fCustomDataAttributeDataType: string;
  fCustomDataAttributeDataSubtype: string;
  fCustomDataCreatedTime: Date;
  fCustomDataCreatedUserId: number;
  fCustomDataUpdatedTime: Date;
  fCustomDataUpdatedUserId: number;
  fCustomDataAttributeCountry: string[];
  fCustomDataAttributeEditableByEmp: boolean;
}
export interface EntityAttributes {
  [key: string]: EntityAttribute[];
}

export interface AttributesPayload {
  allAttributes: EntityAttributes;
}

export enum EntityActionsPrefixes {
  FETCH_ATTRIBUTES = 'entity/FETCH_ATTRIBUTES',
}
export type StoreState = {
  allAttributes: EntityAttributes;
  isLoading: boolean;
  hasData: boolean;
  failedToLoad: boolean;
};

const initialState: StoreState = {
  allAttributes: {},
  isLoading: false,
  hasData: false,
  failedToLoad: false,
};

export const getEntityAttributes = async (
  entity: string,
): Promise<EntityAttributes> => {
  const attributes = await fetchFromOldApi(
    `/json/customdata/entity/${entity}/attribute`,
  ).then((r) => r.json());
  return attributes;
};

export const getAttributes = createAsyncThunk<EntityAttributes, string>(
  EntityActionsPrefixes.FETCH_ATTRIBUTES,
  async (entity: string): Promise<EntityAttributes> => {
    return getEntityAttributes(entity);
  },
);

export const attributesSlice = createSlice({
  name: '~/data/attributes',
  initialState,
  reducers: {},
  extraReducers: {
    [getAttributes.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<unknown>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.allAttributes = action.payload as EntityAttributes;
      state.hasData = true;
    },
    [getAttributes.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [getAttributes.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const entityAttributes = attributesSlice.reducer;
